import React, {useCallback, useState, useRef} from 'react';
import { Form } from '@unform/web';
import { toast } from "react-toastify";
import * as Yup from 'yup';

import NativeSelect from '../NativeSelect';
import Input from '../Input';

import getValidationErrors from '../../utils/getValidationErrors';

import api from '../../services/api';
const AddChild = ({setModalState}) => {
  const [modalLoading, setModalLoading] = useState(false);
  const formRef = useRef(null);
  const token = localStorage.getItem("@Ocariot:token");

  const createNewChild = useCallback(async (data) => {
    try {
      formRef.current?.setErrors({});
      const schema = Yup.object().shape({
        parent: Yup.object().shape({
          cpf: Yup.string().required('CPF neceśsário'),
          name: Yup.string().required('Nome neceśsário'),
          email: Yup.string().required('Email neceśsário'),
          birth: Yup.string().required('Data de nascimento necessária'),
        }),
        child: Yup.object().shape({
          name: Yup.string().required('Nome neceśsário'),
          genre: Yup.string().required('Gênero neceśsário'),
          birth: Yup.string().required('Data de nascimento necessária'),
          class: Yup.string().required('Classe neceśsária'),
        }),
      });

      await schema.validate(data, { abortEarly: false });
      setModalLoading(true);

      await api.post('parent', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setModalLoading(false);
      toast.success('Criança criada com sucesso!');
      setModalState(false);

    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err)
        formRef.current?.setErrors(errors);
        return;
      }
      console.log(err);
      toast.error('Falha ao criar novo usuário. Por favor tente novamente');
    }
  }, []);
  return (
    <Form className="add-child" ref={formRef} onSubmit={createNewChild}>
      <h3>Informações do responsável</h3>
      <div className="parent-info">
        <div className="input-div">
          <label>CPF</label>
          <Input type="tel" name="parent.cpf" mask="999.999.999-99" />
        </div>
        <div className="input-div">
          <label>Email</label>
          <Input type="date" name="parent.email" />
        </div>
        <div className="input-div">
          <label>Nome</label>
          <Input type="text" name="parent.name" />
        </div>
        <div className="input-div">
          <label>Data de aniversário</label>
          <Input type="date" name="parent.birth" />
        </div>
      </div>
      <h3>Informações da criança</h3>
      <div className="parent-info">
        <div className="input-div">
          <label>Nome</label>
          <Input type="text" name="child.name" />
        </div>
        <div className="input-div">
          <label>Classe</label>
          <NativeSelect type="text" name="child.class">
            <option value="" hidden>Selecione uma classe</option>
            <option value="2º ano">2º ano</option>
            <option value="3º ano">3º ano</option>
            <option value="4º ano">4º ano</option>
            <option value="5º ano">5º ano</option>
            <option value="6º ano">6º ano</option>
          </NativeSelect>
        </div>
        <div className="input-div">
          <label>Sexo</label>
          <NativeSelect type="text" name="child.genre">
            <option value="" hidden>Selecione o sexo</option>
            <option value="feminino">Feminino</option>
            <option value="masculino">Masculino</option>
          </NativeSelect>
        </div>
        <div className="input-div">
          <label>Data de aniversário</label>
          <Input type="text" name="child.birth" />
        </div>

      </div>
      <button className="submit-button" type="submit">Adicionar</button>
    </Form>
  );
}

export default AddChild;